import { Map } from 'immutable'
import * as API from '../../utils/API'
import { loading, loadingSuccess, loadingFailure } from './status'
import mergePayload from './utils/mergePayload'
import toQueryString from './utils/toQueryString'

const RESOURCE_NAME = 'indexador'
const ENDPOINT = '/acl/indexadores'

const resolve = (dispatch, resource) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(loadingIndexadorSuccess(resource))
  return Promise.resolve(resource)
}

const resolveDestroy = (dispatch, id) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(destroyingIndexadorSuccess(id))
  return Promise.resolve()
}

const reject = (dispatch, error) => {
  dispatch(loadingFailure(RESOURCE_NAME, error))
  return Promise.reject(error)
}

export const LOADING_INDEXADOR_SUCCESS = 'LOADING_INDEXADOR_SUCCESS'
export function loadingIndexadorSuccess(indexador) {
  return {
    type: LOADING_INDEXADOR_SUCCESS,
    indexador,
  }
}

export const DESTROYING_INDEXADOR_SUCCESS = 'DESTROYING_INDEXADOR_SUCCESS'
export function destroyingIndexadorSuccess(indexadorId) {
  return {
    type: DESTROYING_INDEXADOR_SUCCESS,
    indexadorId,
  }
}

export function fetchMultipleIndexador(params = {}) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(ENDPOINT+ toQueryString(params)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function fetchIndexador(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(`${ENDPOINT}/${id}`).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function createIndexador(indexador) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(ENDPOINT, 'POST', indexador).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function updateIndexador(id, indexador) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(`${ENDPOINT}/${id}`, 'PUT', indexador).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function destroyIndexador(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return await API.call(`${ENDPOINT}/${id}`, 'DELETE').then(
      () => resolveDestroy(dispatch, id),
      error => reject(dispatch, error)
    )
  }
}

const indexador = (state = new Map({}), action) => {
  switch (action.type) {
    case LOADING_INDEXADOR_SUCCESS: {
      const { indexador: payload } = action
      return mergePayload(state, payload)
    }

    case DESTROYING_INDEXADOR_SUCCESS:
      return state.delete(action.indexadorId.toString())

    default:
      return state
  }
}

export default indexador
